export type UserInputType = "url";

export const validateUserInput = (
  type: UserInputType,
  value: string,
  template?: string,
) => {
  const validator = validators[type] ?? validators.url;
  return validator(value, template);
};

export const getUserInputPlaceholder = (
  type: UserInputType,
  template: string,
) => {
  return template.replaceAll(/\*+(\/\*+)*/g, "...");
};

const validators: Record<
  UserInputType,
  (value: string, template?: string) => string
> = {
  url: (value, template) => {
    value = value.trim();
    if (!/^https?:\/\//i.test(value)) {
      value = `https://${value}`;
    }

    const url = new URL(value);

    if (!url.protocol.startsWith("http")) {
      throw new Error("Invalid protocol");
    }

    if (!/[^.]+\.[^.]+$/i.test(url.hostname)) {
      throw new Error("Invalid hostname");
    }

    if (url.username || url.password) {
      throw new Error("Username and password are not allowed");
    }

    if (template) {
      const link = url.hostname + url.pathname + url.search;

      const regex = new RegExp(
        "^" +
          escapeRegExp(template ?? "")
            .replaceAll("\\*\\*", ".+")
            .replaceAll("\\*", "[^/]+") +
          "$",
        "i",
      );

      if (
        !regex.test(url.href) &&
        !regex.test(link) &&
        !regex.test(link.replace(/^www\./, ""))
      ) {
        throw new Error("Template mismatch");
      }
    }

    return url.href;
  },
};

const escapeRegExp = (str: string) =>
  str.replaceAll(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
